import { render, staticRenderFns } from "./UseMego.vue?vue&type=template&id=0edc4c0a&scoped=true&"
import script from "./UseMego.vue?vue&type=script&lang=js&"
export * from "./UseMego.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edc4c0a",
  null
  
)

export default component.exports